import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router';
import { Title, Text, Card, Stack, List, ThemeIcon } from '@mantine/core';
import { IconCheck, IconStar, IconUsers, IconShield } from '@tabler/icons-react';

export const Route = createFileRoute('/about')({  
  component: AboutComponent,
})

function AboutComponent() {
  const features = [
    'Real-time order management',
    'Comprehensive menu control',
    'Customer relationship management',
    'Advanced analytics and reporting',
    'Multi-device responsive design',
    'Secure payment processing'
  ];

  return (
    <div className="space-y-6">
      <div>
        <Title order={1} className="text-gray-900 mb-2">
          About Restaurant Portal
        </Title>
        <Text className="text-gray-600">
          Your complete restaurant management solution
        </Text>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Stack gap="md">
            <div className="flex items-center gap-3">
              <ThemeIcon color="blue" variant="light" size="lg">
                <IconStar size={24} />
              </ThemeIcon>
              <Title order={3}>Our Mission</Title>
            </div>
            <Text className="text-gray-600">
              To empower restaurant owners with cutting-edge technology that streamlines operations, 
              enhances customer experience, and drives business growth. We believe in making restaurant 
              management simple, efficient, and profitable.
            </Text>
          </Stack>
        </Card>

        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Stack gap="md">
            <div className="flex items-center gap-3">
              <ThemeIcon color="green" variant="light" size="lg">
                <IconUsers size={24} />
              </ThemeIcon>
              <Title order={3}>Why Choose Us</Title>
            </div>
            <Text className="text-gray-600">
              With years of experience in the hospitality industry, we understand the unique challenges 
              restaurants face. Our platform is built by restaurant professionals, for restaurant professionals.
            </Text>
          </Stack>
        </Card>
      </div>

      <Card shadow="sm" padding="lg" radius="md" withBorder>
        <Stack gap="md">
          <div className="flex items-center gap-3">
            <ThemeIcon color="orange" variant="light" size="lg">
              <IconCheck size={24} />
            </ThemeIcon>
            <Title order={3}>Key Features</Title>
          </div>
          <List
            spacing="sm"
            size="sm"
            icon={
              <ThemeIcon color="blue" size={20} radius="xl">
                <IconCheck size={12} />
              </ThemeIcon>
            }
          >
            {features.map((feature, index) => (
              <List.Item key={index}>{feature}</List.Item>
            ))}
          </List>
        </Stack>
      </Card>

      <Card shadow="sm" padding="lg" radius="md" withBorder className="bg-blue-50">
        <Stack gap="md">
          <div className="flex items-center gap-3">
            <ThemeIcon color="blue" variant="filled" size="lg">
              <IconShield size={24} />
            </ThemeIcon>
            <Title order={3} className="text-blue-900">
              Security & Reliability
            </Title>
          </div>
          <Text className="text-blue-800">
            Your data security is our top priority. We use enterprise-grade encryption, 
            regular security audits, and comply with industry standards to ensure your 
            restaurant data is always protected and accessible when you need it.
          </Text>
        </Stack>
      </Card>
    </div>
  )
}
